import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('ERROR', {
  STORE_INTERNAL_ERROR: null,
  SHOW_ERROR_PAGE: null
});
